import { useMemo, type ReactNode } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useAppSelector } from '@/store/hooks';
import { selectThemeMode } from '@/store/slices/theme.selectors';
import { createAppTheme } from '@/theme';

export function AppThemeProvider({ children }: { children: ReactNode }) {
  const mode = useAppSelector(selectThemeMode);
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
